import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  Home,
  BookOpen,
  User,
  Settings,
  BarChart3,
  Users,
  FileText,
  Award,
  ChevronLeft,
  ChevronRight
} from 'lucide-react';

const Sidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const location = useLocation();
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';

  const navigation = [
    { name: 'Accueil', href: '/', icon: Home },
    { name: 'Cours', href: '/courses', icon: BookOpen },
    { name: 'Profil', href: '/profile', icon: User },
    { name: 'Paramètres', href: '/settings', icon: Settings },
  ];

  const isActive = (href) => location.pathname.startsWith(href) && (href !== '/' || location.pathname === '/');

  return (
    <div
      className={`bg-white border-r border-gray-200 h-full flex flex-col transition-all duration-300 ${
        isCollapsed ? 'w-16' : 'w-60'
      }`}
    >
      {/* Header de la sidebar */}
      <div className="p-4 border-b border-gray-200">
        <div className="flex items-center justify-between">
          {!isCollapsed && (
            <div className="flex items-center space-x-2">
              <div className="w-6 h-6 bg-primary rounded"></div>
              <span className="font-semibold text-text">Menu</span>
            </div>
          )}
          <button
            onClick={() => setIsCollapsed(!isCollapsed)}
            className="p-1 rounded hover:bg-gray-100 transition-colors duration-200"
          >
            {isCollapsed ? (
              <ChevronRight className="w-4 h-4 text-gray-500" />
            ) : (
              <ChevronLeft className="w-4 h-4 text-gray-500" />
            )}
          </button>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4">
        <ul className="space-y-2">
          {navigation.map((item) => {
            const Icon = item.icon;
            return (
              <li key={item.name}>
                <Link
                  to={item.href}
                  className={`flex items-center space-x-3 px-3 py-2 rounded-lg transition-all duration-200 ${
                    isActive(item.href)
                      ? 'bg-primary text-white'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                  }`}
                >
                  <Icon className="w-5 h-5 flex-shrink-0" />
                  {!isCollapsed && (
                    <span className="font-medium">{item.name}</span>
                  )}
                </Link>
              </li>
            );
          })}
        </ul>

        {/* Section admin — visible uniquement pour les administrateurs */}
        {!isCollapsed && isAdmin && (
          <>
            <div className="mt-8 pt-6 border-t border-gray-200">
              <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">
                Administration
              </h3>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/admin"
                    className="flex items-center space-x-3 px-3 py-2 rounded-lg text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-all duration-200"
                  >
                    <BarChart3 className="w-5 h-5" />
                    <span className="font-medium">Tableau de bord</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/users"
                    className="flex items-center space-x-3 px-3 py-2 rounded-lg text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-all duration-200"
                  >
                    <Users className="w-5 h-5" />
                    <span className="font-medium">Utilisateurs</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/reports"
                    className="flex items-center space-x-3 px-3 py-2 rounded-lg text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-all duration-200"
                  >
                    <FileText className="w-5 h-5" />
                    <span className="font-medium">Rapports</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/admin/certificates"
                    className="flex items-center space-x-3 px-3 py-2 rounded-lg text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-all duration-200"
                  >
                    <Award className="w-5 h-5" />
                    <span className="font-medium">Certificats</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/admin/certificate-settings"
                    className="flex items-center space-x-3 px-3 py-2 rounded-lg text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-all duration-200"
                  >
                    <FileText className="w-5 h-5" />
                    <span className="font-medium">Modèle certificat</span>
                  </Link>
                </li>
              </ul>
            </div>
          </>
        )}
      </nav>

      {/* Footer de la sidebar */}
      <div className="p-4 border-t border-gray-200">
        <div className="text-center">
          {!isCollapsed ? (
            <div className="text-xs text-gray-500">
              <p>Innovactive360°</p>
              <p>MOOC Platform</p>
            </div>
          ) : (
            <div className="w-6 h-6 bg-primary rounded mx-auto"></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
